import { LowerCasePipe } from '@angular/common';
import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';
import { UserContentItem } from '@polaris-customerweb/sharedcomponents.user-content';
import { orderBy } from 'lodash-es';
import { IsIncludedPipe } from 'src/app/pipes/is-included.pipe';
import { RemoveWhiteSpacePipe } from 'src/app/pipes/remove-whitespace.pipe';
import { UserContentSelectItemComponent } from '../user-content-select-item/user-content-select-item.component';

@Component({
    imports: [
        LowerCasePipe,
        RemoveWhiteSpacePipe,
        UserContentSelectItemComponent,
        IsIncludedPipe,
    ],
    selector: 'rdx-user-content-select-list',
    styleUrls: ['./user-content-select-list.component.scss'],
    templateUrl: './user-content-select-list.component.html',
})
export class UserContentSelectListComponent implements OnChanges {
    @Input() userContentItems: UserContentItem[] = [];
    @Input() selectedUserContentItems: UserContentItem[] = [];

    @Output() selectToggled = new EventEmitter<UserContentItem>();

    displayedItems: UserContentItem[] = [];
    selectedItemIds: string[] = [];

    ngOnChanges(changes: SimpleChanges): void {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (changes.userContentItems) {
            this.sortItems();
        }

        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (changes.selectedUserContentItems) {
            this.selectedItemIds = this.selectedUserContentItems.map(
                (item) => item.id
            );
        }
    }

    private sortItems(): void {
        const sortedItems = orderBy(
            this.userContentItems,
            'modificationDate',
            'desc'
        );
        this.displayedItems = sortedItems;
    }
}
